/**
 * Herramientas cliente SNAT embebidas vs hub centralizado.
 * Vue CLI: variables VUE_APP_SNAT_* en .env
 *
 * - Nativo (cuadernos + ticket en la app): VUE_APP_SNAT_NATIVE_CLIENT_TOOLS (default on)
 * - Externo (enlace al hub unificado): VUE_APP_SNAT_EXTERNAL_CLIENT_TOOLS + VUE_APP_SNAT_EXTERNAL_HUB_URL
 */

function envBool(raw, defaultValue) {
  if (raw == null || String(raw).trim() === '') return defaultValue;
  const v = String(raw).trim().toLowerCase();
  if (v === '1' || v === 'true' || v === 'yes' || v === 'on') return true;
  if (v === '0' || v === 'false' || v === 'no' || v === 'off') return false;
  return defaultValue;
}

export function snatNativeClientToolsEnabled() {
  const primary = process.env.VUE_APP_SNAT_NATIVE_CLIENT_TOOLS;
  if (primary != null && String(primary).trim() !== '') {
    return envBool(primary, true);
  }
  return envBool(process.env.VUE_APP_SNAT_NATIVE_NOTEBOOKS, true);
}

export function snatExternalClientToolsEnabled() {
  return envBool(process.env.VUE_APP_SNAT_EXTERNAL_CLIENT_TOOLS, false);
}

export function snatExternalHubUrl() {
  return (process.env.VUE_APP_SNAT_EXTERNAL_HUB_URL || '').trim();
}

export function snatExternalHubLabel() {
  const s = (process.env.VUE_APP_SNAT_EXTERNAL_HUB_LABEL || '').trim();
  return s || 'SNAT centralizado';
}

export function snatExternalHubVisible() {
  return snatExternalClientToolsEnabled() && Boolean(snatExternalHubUrl());
}
